// 模块模式（ModuleEnum）

// 测试模块 TEST_MODULE 同步测 改为 测试
// 学习模块 STUDY_MODULE 同步学 改为 学习
// 重学模块 RESTUDY_MODULE 重学
// 复习模块 REVIEW_MODULE 复习
// 补漏测模块 TEST_CHECK_MODULE 补漏测
// 补漏学模块 STUDY_CHECK_MODULE 补漏学

// 模块枚举

import { getUserLocalData } from '@/utils/auth'
let ModuleEnum = {
    // 1 测试 测试
    'TEST_MODULE&TEST_MODULE&BYRULES': {
        switchMode: 'noChange',
        tips: ''
    },
    // 2 测试 补漏测
    'TEST_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '系统发现你的基础不够牢固，我们帮你巩固一下基础。'
    },
    'TEST_MODULE&TEST_CHECK_MODULE&BYTIMES': {
        switchMode: 'light',
        tips: '你的基础不够牢固，我们帮你巩固一下。'
    },
    // 3 测试 补漏学
    'TEST_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '让我们把之前发现的一些薄弱的知识点补习一下吧！'
    },
    'TEST_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '让我们把之前发现的薄弱的知识点补一下。'
    },
    // 4 测试 学习
    'TEST_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '你有一些知识点掌握得不好，我们为你安排了针对性学习，接下来，让我们一起来把这部分内容补上吧！'
    },
    'TEST_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '让我们一起学习还未学完的知识点吧！'
    },
    // 5 测试 重学
    'TEST_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '测试结束，让我们重学一下之前没学会的知识点吧！'
    },
    'TEST_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '测试结束，让我们重学一下之前没学会的知识点吧！'
    },
    // 6 测试 复习
    'TEST_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '《论语》中说道：温故而知新。那么接下来，让我们一起来巩固一下学过的知识点吧！'
    },
    'TEST_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '让我们复习巩固一下重要的知识吧！'
    },
    // 7 补漏测 测试
    'TEST_CHECK_MODULE&TEST_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '测试结束一半了，继续加油！'
    },
    'TEST_CHECK_MODULE&TEST_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '测试结束一半了，继续加油！'
    },
    // 8 补漏测 补漏测
    'TEST_CHECK_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '测试结束一半了，继续加油！'
    },
    'TEST_CHECK_MODULE&TEST_CHECK_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '测试结束一半了，继续加油！'
    },
    // 9 补漏测 补漏学
    'TEST_CHECK_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '测试结束了，接下来，让我们一起学一下没掌握的知识点吧！'
    },
    'TEST_CHECK_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '测试结束了，让我们学一下没掌握的知识点吧！'
    },
    // 10 补漏测 学习
    'TEST_CHECK_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '测试结束了，接下来，让我们一起学习较难的知识吧！'
    },
    'TEST_CHECK_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '测试结束了，接下来，让我们一起学习较难的知识吧！'
    },
    // 11 补漏测 重学
    'TEST_CHECK_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '测试结束，让我们重学之前没学会的知识吧！'
    },
    'TEST_CHECK_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '测试表现不错，我让我们重新学习以前没掌握的知识点吧！'
    },
    // 12 补漏测 复习
    'TEST_CHECK_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '知识点都测完了，再巩固学习一下吧！'
    },
    'TEST_CHECK_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '知识点都测完了，再巩固学习一下吧！'
    },
    // 13 补漏测 测试
    'STUDY_CHECK_MODULE&TEST_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习暂告一段落，让我们换一个学习方式，先测试一下吧！'
    },
    'STUDY_CHECK_MODULE&TEST_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习暂告一段落，让我们换一个学习方式，先测试一下吧！'
    },
    // 14 补漏学 补漏测
    'STUDY_CHECK_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '知识点掌握得不好，可能是因为前序的知识点没掌握，再测一下吧！'
    },
    'STUDY_CHECK_MODULE&TEST_CHECK_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '知识点掌握得不好，可能是因为前序的知识点没掌握，再测一下吧！'
    },
    // 15 补漏学 补漏学 不提示 不切换
    'STUDY_CHECK_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'noChange',
        tips: ''
    },
    'STUDY_CHECK_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'noChange',
        tips: ''
    },
    // 16 补漏学 学习
    'STUDY_CHECK_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '基础知识点学习暂时结束，让我们学习一些较难的知识吧！'
    },
    'STUDY_CHECK_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '基础知识点学习暂时结束，让我们学习一些较难的知识吧！'
    },
    // 17 补漏学 重学
    'STUDY_CHECK_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，接下来，让我们重新学习一下之前没学会的知识吧！'
    },
    'STUDY_CHECK_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，接下来，让我们重新学习一下之前没学会的知识吧！'
    },
    // 18 补漏学 复习
    'STUDY_CHECK_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习结束了，下面让我们调整一下，复习一下知识吧！'
    },
    'STUDY_CHECK_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习结束了，下面让我们调整一下，复习一下知识吧！'
    },
    // 19 学习 测试
    'STUDY_MODULE&TEST_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习告一段落，接下来，让我们考验一下你对新知识点的掌握程度吧！'
    },
    'STUDY_MODULE&TEST_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习告一段落，接下来，让我们考验一下你对新知识点的掌握程度吧！'
    },
    // 20 学习 补漏测
    'STUDY_MODULE&TEST_CHECK_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，接下来，我们帮你再巩固一下基础。'
    },
    'STUDY_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，接下来，我们帮你再巩固一下基础。'
    },
    // 21 学习 补漏学
    'STUDY_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '学习告一段落，把遗留下来的知识补上吧！'
    },
    'STUDY_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '学习告一段落，把遗留下来的知识补上吧！'
    },
    // 22 学习 学习
    'STUDY_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '学得很认真，再接再厉，继续在知识的海洋中探索吧！'
    },
    'STUDY_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '学得很认真，再接再厉，继续在知识的海洋中探索吧！'
    },
    // 23 学习 重学
    'STUDY_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '你有未掌握的知识点，可能是因为没有找到正确的解题思路，让我们再来学一次吧！'
    },
    'STUDY_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '再学一下没掌握的知识吧！'
    },
    // 24 学习 复习
    'STUDY_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学而时习之,不亦说乎？那么，让我们一起来回顾一下之前学习的内容吧！'
    },
    'STUDY_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学而时习之,不亦说乎？那么，让我们一起来回顾一下之前学习的内容吧！'
    },
    // 25 重学 测试
    'RESTUDY_MODULE&TEST_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习告一段落，接下来，测一下新的知识点吧！'
    },
    'RESTUDY_MODULE&TEST_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习告一段落，接下来，测一下新的知识点吧！'
    },
    // 26 重学 补漏测
    'RESTUDY_MODULE&TEST_CHECK_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，巩固一下基础吧！'
    },
    'RESTUDY_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学习暂时结束，巩固一下基础吧！'
    },
    // 27 重学 补漏学
    'RESTUDY_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'light',
        tips: '学习暂时结束，再打一下基础吧！'
    },
    'RESTUDY_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '学习暂时结束，再打一下基础吧！'
    },
    // 28 重学 学习
    'RESTUDY_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'noChange',
        tips: ''
    },
    'RESTUDY_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'noChange',
        tips: ''
    },
    // 29 重学 重学
    'RESTUDY_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'noChange',
        tips: ''
    },
    'RESTUDY_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'noChange',
        tips: ''
    },
    // 30 重学 复习
    'RESTUDY_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '学得不错，再复习巩固一下吧！'
    },
    'RESTUDY_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '学得不错，再复习巩固一下吧！'
    },
    // 31 复习 测试
    'REVIEW_MODULE&TEST_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    'REVIEW_MODULE&TEST_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    // 32 复习 补漏测
    'REVIEW_MODULE&TEST_CHECK_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    'REVIEW_MODULE&TEST_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    // 33  复习 补漏学
    'REVIEW_MODULE&STUDY_CHECK_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    'REVIEW_MODULE&STUDY_CHECK_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    // 34 复习 学习
    'REVIEW_MODULE&STUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    'REVIEW_MODULE&STUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '鲜花！掌声！记得要定期复习，接下来，让我们追踪一下其他知识点的掌握情况吧！'
    },
    // 35 复习 重学
    'REVIEW_MODULE&RESTUDY_MODULE&BYTIMES':{
        switchMode: 'heavy',
        tips: '复习暂时结束，接下来，我们重新学习一下没掌握好的知识吧！'
    },
    'REVIEW_MODULE&RESTUDY_MODULE&BYRULES':{
        switchMode: 'heavy',
        tips: '复习暂时结束，接下来，我们重新学习一下没掌握好的知识吧！'
    },
    // 36 复习 复习
    'REVIEW_MODULE&REVIEW_MODULE&BYRULES':{
        switchMode: 'noChange',
        tips: ''
    },
    'REVIEW_MODULE&REVIEW_MODULE&BYTIMES':{
        switchMode: 'noChange',
        tips: ''
    },
    // 37 无 测试
    'NULL&TEST_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '欢迎来到松鼠AI，先测一下你的知识点掌握情况吧！'
    },
    // 42 无 复习
    'NULL&REVIEW_MODULE&BYRULES':{
        switchMode: 'light',
        tips: '温故一下学过的知识点，打好扎实的基础吧！'
    },
    // 43 测试 无
    'TEST_MODULE&NULL&BYRULES':{
        switchMode: 'heavy',
        tips: '测试结束了，持之以恒是学习的硬道理！'
    },
    // 45 补漏学 无
    'STUDY_CHECK_MODULE&NULL&BYRULES':{
        switchMode: 'heavy',
        tips: '打好基础，后续学习会才会更轻松的，因为学习是一个循序渐进的过程'
    },
    // 46 学习 无
    'STUDY_MODULE&NULL&BYRULES':{
        switchMode: 'heavy',
        tips: '读书如逆水行舟，坚持到底，就是胜利！'
    },
    // 47 重学 无
    'RESTUDY_MODULE&NULL&BYRULES':{
        switchMode: 'heavy',
        tips: '阳光总在风雨后，你的努力，终有一天会感动上苍的！'
    },
    // 48 复习 无
    'REVIEW_MODULE&NULL&BYRULES':{
        switchMode: 'heavy',
        tips: '温故而知新，虽然知识点你学会的，但是还是要常常再复习一下哦！这样你的基础才会更牢固！'
    },
    // 49 测试模块结束 无可学知识点
    'TEST_MODULE&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 50 重学模块结束 无可学知识点
    'RESTUDY_MODULE&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 51 学习模块结束 无可学知识点
    'STUDY_MODULE&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 52 复习模块结束 无可学知识点
    'REVIEW_MODULE&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 53 补漏学模块结束 无可学知识点
    'STUDY_CHECK_MODULE&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 54 遗忘复习结束 无可学知识点
    'NULL&SECTION_OVER&BYRULES': {
        switchMode: 'heavy',
        tips: ''
    },
    // 追根溯源中，知识点被放弃导致补漏中断
    'TEST_CHECK_MODULE&SECTION_OVER&BYRULES':{
        switchMode: 'heavy',
        tips: ''
    }
}
// 刷新不跳转的路由
const NO_SWITCH_ROUTES = ['target', 'importVideo', 'knowledge', 'pointVideo']

// 章节结束Tips的三种区分文案
const SECATION_OVER_TIPS = {
    NO_UNLOCK_STUDY: '暂时没有任何可以学习的内容哦，去错题训练营消灭错题或者联系老师解锁更多的学习内容~',
    COMP_REVIEW_CD: '恭喜你，本章全部学完！建议你现在可以去错题训练营消灭错题。',
    COMP_NO_REVIEW: '恭喜你，本章全部学完！建议你现在可以去错题训练营消灭错题。',

    COMP_REVIEW: '恭喜你，本章全部学完！建议你现在可以去错题训练营消灭错题、完成遗忘复习，巩固知识。',
    TEMP_REVIEW_CD: '目前没有学习内容了，建议你联系老师解锁新的课次，也可以去错题训练营消灭错题。',
    TEMP_REVIEW: '目前没有学习内容了，建议你联系老师解锁新的课次，也可以去错题训练营消灭错题、巩固复习。',
    TEMP_NO_REVIEW: '目前没有学习内容了，建议你联系老师解锁更多学习内容，也可以去错题训练营消灭错题。',
}

const createRouter = (data, toRoute) => {
    // pageName 页面路由名称
    // prePoolCode 上一个模块 是否会为空 （不是头次进入后，在先行阶段会如何返回）？
    // curPoolCode 下一个模块 当前模块
    // preLoCode 上一个知识点
    // curLoCode 下一个知识点
    // isReview ‘0’ 是否是遗忘复习 0 否 1 是
    // "switchTag": "1", 0  不切 1 切
    // "switchReason": "BYRULES", BYRULES规则纬度 BYTIMES时间纬度
    // "activity": "DQUEST" DQUEST 做题 RVIDEO 视频 LO知识点

    const { activityType, usage } = data.activity;
    const { resource } = data.source;
    let { prePoolCode, curPoolCode, preLoCode, curLoCode, sectionOver, switchTag, switchReason } = data.moduleInfo;

    // 新模块映射旧模块
    // SURFACE_TEST_MODULE 模块补漏测，映射为补漏测
    // SURFACE_STUDY_MODULE 模块补漏学，映射为补漏学
    // SURFACE_RESTUDY_MODULE 模块补漏重学，映射为重学
    // 原始数据保留模块枚举，仅在展现的时候进行映射。
    switch (prePoolCode) {
        case 'SURFACE_TEST_MODULE' :
            prePoolCode = 'TEST_CHECK_MODULE'
            break
        case 'SURFACE_STUDY_MODULE' :
            prePoolCode = 'STUDY_CHECK_MODULE'
            break
        case 'SURFACE_RESTUDY_MODULE' :
            prePoolCode = 'RESTUDY_MODULE'
            break
    }

    switch (curPoolCode) {
        case 'SURFACE_TEST_MODULE' :
            curPoolCode = 'TEST_CHECK_MODULE'
            break
        case 'SURFACE_STUDY_MODULE' :
            curPoolCode = 'STUDY_CHECK_MODULE'
            break
        case 'SURFACE_RESTUDY_MODULE' :
            curPoolCode = 'RESTUDY_MODULE'
            break
    }

    const { chapter_type } = getUserLocalData();
    let component = Object.assign({}, {
        activityType, // action type
        isPreTest: prePoolCode === 'TEST_MODULE' || prePoolCode === 'TEST_CHECK_MODULE', // 上个模块是否是测试模块：true 测试 false 学习
        isCurTest: curPoolCode === 'TEST_MODULE' || curPoolCode === 'TEST_CHECK_MODULE', // 当前模块是否是测试模块：true 测试 false 学习
        isCurTestModal: prePoolCode === 'TEST_MODULE',
        id: 'question', //  路由ID 默认都是取题
        tips: '', // 提示信息
        switchMode: 'noChange' // heavy 重切换 light 轻切换 (显示tips)
    })

    // 模块拼接
    prePoolCode = prePoolCode ? prePoolCode : 'NULL';
    curPoolCode = curPoolCode ? curPoolCode : 'NULL';

    const ModuleEnumStr = prePoolCode + '&' + curPoolCode + '&' + switchReason;

    // 章节结束处理
    if (curPoolCode === 'SECTION_OVER') {
        if(ModuleEnum[ModuleEnumStr]){
            ModuleEnum[ModuleEnumStr].tips = SECATION_OVER_TIPS[sectionOver]
        } else {
            this.$message.error('未匹配到对应模块');
        }
    }

    // 需要获取 模块之间的切换模式 枚举
    // 1 切换  0 不切

    if(switchTag == 1) {
        // 判断模块切换方式
        if(ModuleEnum[ModuleEnumStr]) {
            const { switchMode, tips } = ModuleEnum[ModuleEnumStr];
            component = Object.assign({}, component, {
                switchMode,
                tips
            });
        }
        //冲刺章  chapter_type 11 switchTag 1  prePoolCode = curPoolCode = studymodule   sectionOver == default
        if(chapter_type == 11 && prePoolCode == 'STUDY_MODULE' && (prePoolCode == curPoolCode) && sectionOver == 'DEFAULT'){
                component.id = 'target';
        } else {
            if(component.switchMode === 'heavy') { // 重切换
                // 如果上一个模块 不存在
                // 上一个模块结果页/学习结果页 新模块过渡页
                // component.id = prePoolCode !== 'NULL' ? 'result' : 'target'

                // component.id = prePoolCode !== 'NULL' ? 'knowledge' : 'target'
                if(prePoolCode !== 'NULL') {

                    component.id = component.isPreTest ? 'result' : 'knowledge'
                }else {
                    component.id = 'target'
                }
            } else { // 轻切换
                // 测试模块 直接取题
                // 学习模块 知识点视频页

                //学习阶段 有可能是视频也有可能是取题 需要根据atvityType 来判断
                let pageType;
                if(preLoCode && preLoCode !== curLoCode){
                    pageType = 'knowledge';
                }else {
                    pageType = (activityType == 'LO' || activityType == 'RESTUDY_LO_VIDEO') ? 'pointVideo' : 'question';
                }
                component.id = component.isCurTest || chapter_type == 8  ? 'question' : pageType;
            }
        }


    } else {
        // 不切换
        if(preLoCode && preLoCode !== curLoCode) { // 上一个知识点与 后一个知识点不同
            // 测试模块 直接取题
            // 学习模块 单个知识点结果页
            component.id = component.isCurTest ? 'question': 'knowledge'
        } else { // 如果知识点相同
            // 特殊情况：相同知识点不发生切换 也可能会进入知识点视频，比如重学

            //学习阶段 有可能是视频也有可能是取题 需要根据atvityType 来判断
            let pageType = (activityType == 'LO' || activityType == 'RESTUDY_LO_VIDEO') ? 'pointVideo' : 'question';
            component.id = (activityType !== 'LO' && activityType !== 'RESTUDY_LO_VIDEO') || chapter_type == 8 ? 'question' : pageType;
        }
    }

    // 上一个模块为空 表示第一次进入
    if(prePoolCode === 'NULL' || toRoute === 'greet') {

        // 用户第一次进入 不作轻提示
        if(activityType !== 'SEC_END' && ModuleEnum[ModuleEnumStr]) {
            const { switchMode } = ModuleEnum[ModuleEnumStr]
            component = Object.assign({}, component, {
                switchMode,
                tips: ''
            });
        }

        switch (activityType) {
            case 'LO':
            case 'RESTUDY_LO_VIDEO':
                component.id = 'pointVideo';
                break;
            case 'RVIDEO':
                // component.id = usage === 'IMPORT' ? 'importVideo' : 'pointVideo';
                component.id = 'importVideo';
                break;
            case 'SEC_END':
                component.id = 'target';
                break;
            default:
                component.id = 'question';
        }
    }
    if (toRoute && activityType !== 'DQUEST') {
        // 在制定页面刷新时，停留在此页面
        if(NO_SWITCH_ROUTES.indexOf(toRoute) !== -1) {
            component.id = toRoute;
        }
    }

    // 遗忘复习
    // if(curPoolCode === 'REVIEW_MODULE'){
    //     component.id = 'question';
    // }
    return component;

}
export default createRouter


// WEBPACK FOOTER //
// ./src/store/createRouter.js